import { Component, Input, Output, EventEmitter, ChangeDetectorRef, ChangeDetectionStrategy, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IKomutTanim, komutVarsayilan } from './fiko-komut.tanim';

/**
 * CATIA tarzı komut penceresi: parametreler değiştikçe CANLI önizleme (yonetici.komutGuncelle),
 * Tamam → daimi (komutOnayla), İptal/Esc → geri al (komutIptal). Sürüklenebilir, futuristik.
 */
@Component({
  selector: 'fikoyt-komut-penceresi',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FormsModule],
  template: `
  <div class="fkp" [style.left.px]="x" [style.top.px]="y" (keydown)="tus($event)">
    <div class="fkp-bas" (pointerdown)="surukleBasla($event)">
      <i class="icon {{ tanim?.ikon }}"></i>
      <span class="fkp-ad">{{ tanim?.etiket }}</span>
      <button class="fkp-kapat" (click)="iptal()" title="İptal (Esc)">✕</button>
    </div>
    <div class="fkp-govde">
      <div class="fkp-alan" *ngFor="let p of tanim?.parametreler; trackBy: trk">
        <label>{{ p.etiket }}</label>
        @switch (p.tip) {
          @case ('metin') {
            <input class="fkp-metin" type="text" [ngModel]="deger[p.anahtar]" (ngModelChange)="degistir(p, $event)" placeholder="Yazı…" />
          }
          @case ('boolean') {
            <button class="fkp-bool" [class.acik]="!!deger[p.anahtar]" (click)="degistir(p, !deger[p.anahtar])">
              {{ deger[p.anahtar] ? 'Evet' : 'Hayır' }}
            </button>
          }
          @case ('secim') {
            <div class="fkp-secim">
              <button *ngFor="let s of p.secenekler" class="fkp-sec" [class.aktif]="deger[p.anahtar]===s.deger" (click)="degistir(p, s.deger)">{{ s.etiket }}</button>
            </div>
          }
          @default {
            <div class="fkp-inp">
              <input type="number" [ngModel]="deger[p.anahtar]" (ngModelChange)="degistir(p, $event)"
                     [min]="p.min ?? null" [max]="p.max ?? null" [step]="p.adim ?? 1" />
              <span class="fkp-birim">{{ p.birim }}</span>
            </div>
          }
        }
      </div>
    </div>
    <div class="fkp-altbar">
      <button class="fkp-btn iptal" (click)="iptal()">İptal</button>
      <button class="fkp-btn tamam" (click)="tamam()">Tamam</button>
    </div>
  </div>
  `,
  styles: [`
    .fkp { position: fixed; z-index: 2147483500; width: 232px; font-family: system-ui, sans-serif; color: #e8f0ff;
      background: linear-gradient(155deg, rgba(16,22,40,.95), rgba(10,14,28,.97));
      border: 1px solid rgba(80,160,255,.32); border-radius: 13px; overflow: hidden;
      box-shadow: 0 0 0 1px rgba(40,90,180,.18), 0 18px 50px rgba(0,0,0,.6), inset 0 1px 0 rgba(120,180,255,.12);
      backdrop-filter: blur(16px); animation: fkpGir .2s cubic-bezier(.2,.9,.3,1); }
    @keyframes fkpGir { from { opacity:0; transform: translateY(8px) scale(.96);} to { opacity:1; transform:none; } }
    .fkp-bas { display:flex; align-items:center; gap:8px; padding:9px 11px; cursor:move; user-select:none;
      background: linear-gradient(90deg, rgba(40,90,180,.32), rgba(30,60,130,.18)); border-bottom:1px solid rgba(90,150,255,.22); }
    .fkp-bas i.icon { font-size:15px; margin:0; color:#67a8ff; filter: drop-shadow(0 0 5px rgba(80,180,255,.7)); }
    .fkp-ad { flex:1; font-weight:700; font-size:13px; letter-spacing:.3px;
      background:linear-gradient(90deg,#bfe0ff,#67a8ff); -webkit-background-clip:text; background-clip:text; color:transparent; }
    .fkp-kapat { background:transparent; border:none; color:#8fa0c8; font-size:13px; cursor:pointer; padding:2px 5px; border-radius:5px; }
    .fkp-kapat:hover { background:rgba(220,60,60,.3); color:#ffb4b4; }
    .fkp-govde { padding:11px; display:flex; flex-direction:column; gap:9px; }
    .fkp-alan label { display:block; font-size:9.5px; color:#7e8db5; margin:0 0 3px 2px; letter-spacing:.4px; text-transform:uppercase; }
    .fkp-inp { display:flex; align-items:center; gap:4px; background:rgba(8,12,24,.7);
      border:1px solid rgba(90,150,255,.24); border-radius:8px; padding:0 9px; transition:.15s; }
    .fkp-inp:focus-within { border-color:rgba(100,180,255,.65); box-shadow:0 0 0 3px rgba(80,150,255,.16); }
    .fkp-inp input { width:100%; background:transparent; border:none; outline:none; color:#eaf2ff; font-size:14px; font-weight:600; padding:8px 0; font-variant-numeric:tabular-nums; }
    .fkp-birim { font-size:10px; color:#5f6e96; font-weight:600; }
    .fkp-metin { width:100%; background:rgba(8,12,24,.7); border:1px solid rgba(90,150,255,.24); border-radius:8px;
      padding:8px 9px; color:#eaf2ff; font-size:13px; font-weight:600; outline:none; }
    .fkp-metin:focus { border-color:rgba(100,180,255,.65); box-shadow:0 0 0 3px rgba(80,150,255,.16); }
    .fkp-bool { width:100%; padding:8px; border-radius:8px; cursor:pointer; font-size:12px; font-weight:600;
      background:rgba(20,28,50,.6); border:1px solid rgba(90,150,255,.24); color:#cdd9f5; transition:.15s; }
    .fkp-bool.acik { background:rgba(34,160,90,.3); border-color:#34d399; color:#9ff0c0; }
    .fkp-secim { display:flex; gap:5px; }
    .fkp-sec { flex:1; padding:8px 0; border-radius:8px; cursor:pointer; font-size:12px; font-weight:600;
      background:rgba(20,28,50,.6); border:1px solid rgba(90,150,255,.24); color:#cdd9f5; transition:.15s; }
    .fkp-sec:hover { border-color:rgba(120,180,255,.6); }
    .fkp-sec.aktif { background:#22d3ee; border-color:#22d3ee; color:#06202a; }
    .fkp-altbar { display:flex; gap:7px; padding:10px 11px; border-top:1px solid rgba(90,150,255,.18); background:rgba(8,12,24,.4); }
    .fkp-btn { flex:1; padding:9px 0; border-radius:9px; cursor:pointer; font-size:12.5px; font-weight:700; transition:.15s; border:1px solid transparent; }
    .fkp-btn.iptal { background:rgba(120,130,160,.2); border-color:rgba(150,160,190,.3); color:#bcc6e0; }
    .fkp-btn.iptal:hover { background:rgba(220,60,60,.25); border-color:#f87171; color:#ffb4b4; }
    .fkp-btn.tamam { background:linear-gradient(135deg,#0ea5e9,#22d3ee); color:#06202a; }
    .fkp-btn.tamam:hover { box-shadow:0 0 14px rgba(34,211,238,.6); transform:translateY(-1px); }
  `]
})
export class FikoKomutPenceresi implements OnInit, OnDestroy {
  @Input() tanim!: IKomutTanim;
  @Input() yonetici: any;
  @Output() kapat = new EventEmitter<boolean>();   // true=onaylandı

  deger: Record<string, any> = {};
  x = 0; y = 0;
  private sur: { dx: number; dy: number } | null = null;
  private hMove = (e: PointerEvent) => this.surukle(e);
  private hUp = () => { this.sur = null; };

  constructor(public CD: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.deger = komutVarsayilan(this.tanim);
    // ekranın sağ-üstüne konumla (3D görünümü kapatmasın)
    this.x = Math.max(20, (typeof window !== 'undefined' ? window.innerWidth : 1000) - 270);
    this.y = 90;
    const ok = this.yonetici?.komutBaslat?.(this.tanim.id, this.deger);
    if (!ok) { this.kapat.emit(false); return; }   // ön koşul yoksa kapat
    window.addEventListener('pointermove', this.hMove);
    window.addEventListener('pointerup', this.hUp);
  }
  ngOnDestroy(): void {
    window.removeEventListener('pointermove', this.hMove);
    window.removeEventListener('pointerup', this.hUp);
  }

  trk = (_: number, p: any) => p.anahtar;
  degistir(p: any, deger: any): void { this.deger[p.anahtar] = deger; this.yonetici?.komutGuncelle?.(p.anahtar, deger); this.CD.markForCheck(); }
  tamam(): void { this.yonetici?.komutOnayla?.(); this.kapat.emit(true); }
  iptal(): void { this.yonetici?.komutIptal?.(); this.kapat.emit(false); }
  tus(e: KeyboardEvent): void { if (e.key === 'Enter') this.tamam(); else if (e.key === 'Escape') this.iptal(); }

  surukleBasla(e: PointerEvent): void { this.sur = { dx: e.clientX - this.x, dy: e.clientY - this.y }; }
  private surukle(e: PointerEvent): void { if (!this.sur) return; this.x = e.clientX - this.sur.dx; this.y = e.clientY - this.sur.dy; this.CD.markForCheck(); }
}
